import { render, staticRenderFns } from "./BtnCancel.vue?vue&type=template&id=45aeda58&scoped=true&"
import script from "./BtnCancel.vue?vue&type=script&lang=js&"
export * from "./BtnCancel.vue?vue&type=script&lang=js&"
import style0 from "./BtnCancel.vue?vue&type=style&index=0&id=45aeda58&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45aeda58",
  null
  
)

export default component.exports